<!-- 我的优惠 -->
<template>
  <div class="discount_my">
  <van-tabs @click="onclick">
    <van-tab title="待使用"></van-tab>
    <van-tab title="已使用"></van-tab>
    <van-tab title="已过期"></van-tab>
  </van-tabs>

  <div class="show_com">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <couponsT v-for="(val, key) in data" :key="key" :data="val" />
      </van-list>
    </van-pull-refresh>
  </div>
 </div>
</template>

<style lang="scss" scoped>
  .show_com {
    margin-top:11px;
    padding: 10px;
    height: calc(100vh - 72px);
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
  }
  .van-tabs__line {
    background: #0081ff;
  }
.van-tab--active {
    color: #0081ff;
  }
</style>
<script>

import couponsT from '@/components/discount/coupons_template'

export default {
  name: 'discount_my',
  components: {couponsT},
  data () {
    return {
      tab: 0,
      loading: false,
      finished: false,
      refreshing: false,
      data: [],
      data_usable: [
        {
          type: 1,
          status: 1,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50
        },
        {
          type: 2,
          status: 1,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50
        },
        {
          type: 3,
          status: 1,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50
        },
        {
          type: 4,
          status: 1,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50
        },
        {
          type: 1,
          status: 1,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50
        }
      ],
      data_used: [
        {
          type: 1,
          status: 2,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50
        },
        {
          type: 2,
          status: 2,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50
        }
      ],
      data_expired: [
        {
          type: 1,
          status: 3,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50
        },
        {
          type: 2,
          status: 3,
          explain: '在线支付有效(有效期180天)',
          date: ['2020-05-22', '2020-05-31'],
          trigger: 300,
          money: 50
        }
      ]
    }
  },

  created () {
    this.get_data()
  },

  methods: {
    // 获取数据
    get_data () {
    },

    // 切换状态
    onclick (index) {
      this.tab = index
      this.get_data()
    },

    // 加载
    onLoad () {
      this.get_data()
    },

    // 刷新
    onRefresh () {
      this.get_data()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/discount/my.vue